"use client";

import React from "react";
import { Crown, Heart, Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  icon: Crown,
  text: "500K+ vizualizări la reels"
}, {
  icon: Trophy,
  text: "Clienți noi din Instagram"
}, {
  icon: Heart,
  text: "Creștere organică pe TikTok"
}];
export default function GarantiaExperientei() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="garanția-experienței" className="dark bg-background text-foreground py-20 md:py-36 overflow-hidden">
      <div ref={ref} className={`container flex flex-col items-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="text-3xl font-extrabold text-center uppercase tracking-tight ![margin:0px_0px_20px_0px] md:text-4xl lg:text-5xl">Rezultate obținute în proiectele noastre:</h2>
        
        <div className="grid grid-cols-1 gap-8 w-full mt-5 mb-6 md:grid-cols-3 lg:gap-12">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group card p-8 transition-all duration-300 hover:scale-[1.02]">
                <div className="mb-6 p-4 rounded-lg bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-300">
                  <Icon className="w-12 h-12 md:w-16 md:h-16 text-primary-500" strokeWidth={1.5} />
                </div>
                <p className="text-lg md:text-xl text-foreground font-medium leading-relaxed max-w-sm">
                  {feature.text}
                </p>
              </div>;
        })}
        </div>

        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <p className="text-base md:text-lg text-foreground/70 mb-5">Strategiile pe care le vei învăța sunt deja testate în piață.<div>*link la portfoliu sau instagram main agency pentru a arata lucrarile</div></p>

          <Button size="lg" onClick={() => document.getElementById('oportunitate-bonus')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-gradient-to-br from-primary-500 to-secondary-500 text-foreground text-lg md:text-xl font-bold px-10 py-8 rounded-xl hover:scale-105 transition-all duration-300 uppercase tracking-wide border-none">
            ÎNSCRIE-TE LA CURS!
          </Button>
        </div>
      </div>
    </section>;
}